import { toast } from "@devhop/ui";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { contractsApi } from "./client";

export function useContractTypesQuery() {
  return useQuery({
    queryKey: ["contract-types"],
    queryFn: () => contractsApi.listTypes(),
  });
}

export function useCreateContractType() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: contractsApi.createType,
    onSuccess: () => {
      toast.success("ສ້າງປະເພດສັນຍາສຳເລັດ");
      queryClient.invalidateQueries({ queryKey: ["contract-types"] });
    },
    onError: (error: Error) => {
      toast.error(error.message || "ສ້າງປະເພດສັນຍາລົ້ມເຫຼວ");
    },
  });
}

export function useUpdateContractType(id: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: Parameters<typeof contractsApi.updateType>[1]) =>
      contractsApi.updateType(id, input),
    onSuccess: () => {
      toast.success("ແກ້ໄຂປະເພດສັນຍາສຳເລັດ");
      queryClient.invalidateQueries({ queryKey: ["contract-types"] });
    },
    onError: (error: Error) => {
      toast.error(error.message || "ແກ້ໄຂປະເພດສັນຍາລົ້ມເຫຼວ");
    },
  });
}

export function useDeleteContractType() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: contractsApi.deleteType,
    onSuccess: () => {
      toast.success("ລຶບປະເພດສັນຍາສຳເລັດ");
      queryClient.invalidateQueries({ queryKey: ["contract-types"] });
    },
    onError: (error: Error) => {
      toast.error(error.message || "ລຶບປະເພດສັນຍາລົ້ມເຫຼວ");
    },
  });
}
